:host {
  background: var(--white-layout-301-level-0-elevation);
}

.wrapper {
  flex-direction: column;
}

.search-query-panel {
  flex: 1;
  height: auto;
}

.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: calc(2 * var(--spacer)) calc(3 * var(--spacer));
}

.company-selector {
  width: auto;
}

.search-app-tab-group {
  flex: auto;
  padding: calc(var(--spacer) * 0.5);

  --tab-header-padding-left: calc(var(--spacer) * 3);
  --tab-header-padding-right: calc(var(--spacer) * 3);
  --tab-body-padding-right: calc(var(--spacer));
  --tab-body-padding-top: 0;
  --tab-body-padding-bottom: 0;
  height: calc(100% - 9 * var(--spacer));
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}
